import axios from 'axios'

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 15000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

http.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.reject(error.response)
})

export default http
